import moment from "moment";
import { Edad } from "../interfaces/mascotasInterfaces";

const mascotaRaza = (raza: string, languaje: string) => {
    switch (raza) {
        case 'mestizo':
            return languaje === 'ES' ? 'Mestizo' : 'Mongrel';
        case 'mezcla de raza con mestizo':
            return languaje === 'ES' ? 'Mezcla de raza con mestizo' : 'Cross-breed';
        case 'de raza':
            return languaje === 'ES' ? 'De raza' : 'Breed';
        default:
            return raza;
    }
};

const mascotaSexo = (sexo: string, languaje: string) => {
    switch (sexo) {
        case 'macho':
            return languaje === 'ES' ? 'Macho' : 'Male';
        case 'hembra':
            return languaje === 'ES' ? 'Hembra' : 'Female';
        default:
            return sexo;
    }
};

const mascotaEspecie = (especie: string, languaje: string) => {
    switch (especie) {
        case 'perro':
            return languaje === 'ES' ? 'Perro' : 'Dog';
        case 'gato':
            return languaje === 'ES' ? 'Gato' : 'Cat';
        default:
            return especie;
    }
};

const mascotaTamano = (tamano: string, languaje: string) => {
    switch (tamano) {
        case 'mini':
            return 'Mini';
        case 'pequeño':
            return languaje === 'ES' ? 'Pequeño' : 'Small';
        case 'mediano':
            return languaje === 'ES' ? 'Mediano' : 'Medium';
        case 'grande':
            return languaje === 'ES' ? 'Grande' : 'Big';
        case 'muy grande':
            return languaje === 'ES' ? 'Muy grande' : 'Giant';
        default:
            return tamano;
    }
};

const mascotaEdad = ({ valor, unidad, nacimiento }: Edad, created_at: string, languaje: string): string => {
    let meses = 0, anios = 0, birtMount=moment();
    if (valor != null && unidad) {
        console.clear()
        
        const b_anios = unidad === 'años' ? valor : 0
        const b_meses = unidad === 'meses' ? valor : 0
        birtMount = moment(created_at)/*.startOf('month')*/.subtract(b_anios,'years').subtract(b_meses,'month')
        
        
    } else if(nacimiento!=null) {
        birtMount = moment(nacimiento)
    }
    const d_meses = moment().diff(birtMount,'month')
        anios = Math.floor(d_meses/12);
        meses = d_meses%12;


    let message = '';
    
    if( anios > 0) {
        message += `${anios} ${languaje === 'ES' ? 'año' : 'year'}${anios>1?'s':''} `
    }
    if( meses > 0) {
        message += `${meses} ${languaje === 'ES' ? 'mes' : 'month'}${anios>1?(languaje === 'ES' ? 'es' : 's'):''} `
    }
    return message
};

const estados: string[] = [
    'Aguascalientes',
    'Baja California',
    'Baja California Sur',
    'Campeche',
    'Coahuila',
    'Colima',
    'Chiapas',
    'Chihuahua',
    'Durango',
    'CDMX',
    'Guanajuato',
    'Guerrero',
    'Hidalgo',
    'Jalisco',
    'México',
    'Michoacán',
    'Morelos',
    'Nayarit',
    'Nuevo León',
    'Oaxaca',
    'Puebla',
    'Querétaro',
    'Quintana Roo',
    'San Luis Potosí',
    'Sinaloa',
    'Sonora',
    'Tabasco',
    'Tamaulipas',
    'Tlaxcala',
    'Veracruz',
    'Yucatán',
    'Zacatecas'
];

export {
    mascotaRaza,
    mascotaSexo,
    mascotaEspecie,
    mascotaTamano,
    mascotaEdad,
    estados
};
